import { Stack, styled, Typography } from '@mui/material'
import { Box } from '@mui/system'

const Body = styled(Stack)``

const LabelSection = styled(Stack)`
  padding: 14px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`

const HeaderLabel = styled(Typography)`
  font-size: 13px;
`

const HeaderSection = styled(Stack)`
  flex-direction: row;
  padding: 12px 14px;
  gap: 10px;
`

const HeaderTitle = styled(Typography)`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.primary};
`

const RowsSection = styled(Stack)`
  gap: 10px;
  margin-bottom: 16px;
`

const RowItem = styled(Stack)`
  flex-direction: row;
  padding: 12px 14px;
  gap: 10px;
  height: 63px;
  background-color: ${({ theme }) => theme.palette.customGrey.five};
`

const ButtonContainer = styled(Box)`
  flex: 1;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
  display: flex;
`

export {
  Body,
  LabelSection,
  HeaderSection,
  HeaderLabel,
  HeaderTitle,
  RowsSection,
  RowItem,
  ButtonContainer,
}
